import React, { Component } from 'react';
import * as actions from '../../language/ducks/actions';
import { connect } from 'react-redux';
import UrlParamsUtil from "../../../services/util/UrlParamsUtil";
import {PropTypes} from 'prop-types';

class LanguageInitializer extends Component {

  componentDidMount() {
    let parsedParams = UrlParamsUtil.getQueryParams(window.location.search);

    if (parsedParams.lang) {
      this.props.setLanguage(parsedParams.lang);
    }
    this.props.updateState('languageInitializer');
  }

  render() {
    return (
        <div></div>
    );
  }
}

LanguageInitializer.propTypes = {
  updateState: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
  return {}
};

export default connect(
    mapStateToProps,
    actions
)(LanguageInitializer);